<input [(ngModel)]="model.field1" (change)="field1Changed($event)"
       type="text" onfocus="(this.type='number')" placeholder="From...">

<input [(ngModel)]="model.field2" (change)="field2Changed($event)"
       type="text" onfocus="(this.type='number')" placeholder="To...">
